module.exports = __webpack_public_path__ + "media/images/icon-order-a2598f44d15cefd0871c42f5f0d8e6e9.svg";